import {dateTimeManager} from "@/Services/TimeManager";
export default {
    name: "time",
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
        /**
         * Fetch GRVs with safe response handling (no double JSON.parse).
         * The backend sometimes returns response as an array/object, other times as a string.
         * This action normalizes it to an array/object and defaults to [] when empty.
         * @param {Object} context Vuex action context
         * @param {Object} payload { supplierTPIN?: string, isProcessed: boolean }
         * @returns {Promise<Array|Object>} normalized backend response
         */
        searchGRVs:(context , payload) =>{
            payload = {
                ...payload,
                ...context.getters.getGlobalDateRange
            }
            return axios.get(portalApi+`grv`,{
                params: payload
            }).then(({data})=>{
                const r = data && data.response;
                if (typeof r === 'string') {
                    const t = r.trim();
                    return t ? JSON.parse(t) : [];
                }
                return Array.isArray(r) || (r && typeof r === 'object') ? r : [];
            }).catch(err=>errorHandler.tomcatError(err))
        },
        searchZRAGRVs:(context , tpin) =>{
            const Apikey = context.getters.getApikey;
            const headers = Apikey ? { 'Api-key': Apikey } : {};
            return axios.get(SmartInvoiceApi+`purchase/getAllInvoicesByTpin?tpin=${tpin}`,{ headers })
                .then(({data})=>data.response)
                .catch(err=>errorHandler.tomcatError(err));
        },
        sendToSmartInvoice:async (context , payload) =>{
            const Apikey = context.getters.getApikey;
            payload.user = "Lyt-SI Client";
            if (Apikey) payload.apiKey = Apikey;
            return context.dispatch(`sendRequest`,{
                url : payload.integrated?portalApi+`grv/process/integrated/${payload.smartInvoiceNum}`:portalApi+`grv/process/nonIntegrated`,
                payload
            }).catch(err=>errorHandler.tomcatError(err));
        }
    }
}
